import React from 'react';

const ClientContactNav = props => {
  const { subject: client, className } = props;
  const { service_addresses = [] } = client;

  if (service_addresses.length > 0)
    return <div className={className}>{service_addresses[0].zip_code}</div>;
  else return '';
};

export default ClientContactNav;



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientContactNav.js